import React, { useEffect } from "react";
import "../../Styles/specific.css";
import spImg from "../../Assets/specificImg.png";
import settings from "../../Assets/settings.png";
import shape from "../../Assets/shape-design.png";
import content from "../../Assets/content-management.png";
function Specification() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".item1, .item2, .item3, .item4, .item5, .item6, .item7, .item8, .item9, .item10, .item11, .item12"
    );

    const handleAnimationStart = (element) => {
      element.style.visibility = "visible";
    };

    elements.forEach((element) => {
      element.addEventListener("animationstart", () => {
        handleAnimationStart(element);
      });

      return () => {
        element.removeEventListener("animationstart", () => {
          handleAnimationStart(element);
        });
      };
    });
  }, []);

  return (
    <div className="specific_wrapper">
      <div className="sp_left">
        <div className="featurs">
          <div className="items item1">
            <div className="logo">
              <img src={shape} alt="" />
            </div>
            Design Elements
          </div>
          <div className="items item2">
            <div className="logo">
              <img src={settings} alt="" />
            </div>
            Functionality
          </div>
          <div className="items item3">
            <div className="logo">
              <img src={content} alt="" />
            </div>
            Content
          </div>
          <div className="items item4 ">
            Responsive Design
            <div className="logo">
              <img src={shape} alt="" />
            </div>
          </div>
          <div className="items item5">
            <div className="logo">
              <img src={settings} alt="" />
            </div>
            User Experience (UX)
          </div>

          <div className="items item6">
            <div className="logo">
              <img src={content} alt="" />
            </div>
            Content Updates
          </div>
          <div className="items item7">
            {" "}
            <div className="logo">
              <img src={shape} alt="" />
            </div>
            Security Measures
          </div>
          <div className="items item8">
            {" "}
            <div className="logo">
              <img src={settings} alt="" />
            </div>
            <div>Performance</div>
            <div>Optimization</div>
          </div>
          <div className="items item9">
            {" "}
            <div className="logo">
              <img src={content} alt="" />
            </div>
            Backup and Recovery
          </div>
          <div className="items item10">
            {" "}
            <div className="logo">
              <img src={shape} alt="" />
            </div>
            Technical Support
          </div>
          <div className="items item11">
            <div className="logo">
              <img src={settings} alt="" />
            </div>
            Analytics{" "}
          </div>
          <div className="items item12">
            {" "}
            <div className="logo">
              <img src={content} alt="" />
            </div>
            Reporting
          </div>
        </div>
        <img src={spImg} alt="" className="sp_img_hide" />
      </div>

      <div className="sp_right">
        <img src={spImg} alt="" className="sp_img" />
      </div>
    </div>
  );
}

export default Specification;
